import React from "react";
import { Button, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useFriendshipModel } from "../friendshipModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";

export const DataBox = () => {
    const { selectedRowKeys,
        setIVisibleDrawer,
        onRemove
    } = useFriendshipModel();
    const onAdd = () => {
        setIVisibleDrawer("add")
    }
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        setIVisibleDrawer("edit")
    }
    const onDelete = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行删除", type: "warning" });
            return;
        }
        onRemove(selectedRowKeys[0])
    }
    const action = <>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onDelete}
        >删除</Button>
    </>

    return (
        <YhBox title="友情链接列表" action={action}>
            <DataTable />
        </YhBox>
    )
}
